// src/pages/Register.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Box, Button, TextField, Typography, Stack, Alert, CircularProgress, Paper, LinearProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import API from "../api";
import { login } from "../auth";
import { indigoGradient, C } from "../theme";

const strength = (p) => [p.length >= 8, /[A-Z]/.test(p), /[0-9]/.test(p), /[^A-Za-z0-9]/.test(p)].filter(Boolean).length;
const COLORS = ["", "#ef4444","#f59e0b","#f59e0b","#22c55e"];
const LABELS = ["", "Faible","Moyen","Bon","Fort"];

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username:"", email:"", full_name:"", password:"", confirm:"" });
  const [loading, setLoading] = useState(false);
  const [err,     setErr]     = useState("");
  const [success, setSuccess] = useState(false);
  const set = k => e => setForm({...form, [k]: e.target.value});
  const s = strength(form.password);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (!form.username || !form.email || !form.password) { setErr("Remplissez les champs obligatoires."); return; }
    if (form.password.length < 6) { setErr("Mot de passe trop court (min. 6 caractères)."); return; }
    if (form.password !== form.confirm) { setErr("Les mots de passe ne correspondent pas."); return; }
    try {
      setLoading(true);
      await API.post("/users/", { username:form.username, email:form.email, full_name:form.full_name||null, password:form.password, is_admin:false });
      await login(form.username, form.password);
      window.dispatchEvent(new Event("auth-changed"));
      setSuccess(true);
      setTimeout(() => navigate("/exams"), 1600);
    } catch { setErr("Impossible de créer le compte. Nom d'utilisateur ou email déjà utilisé ?"); }
    finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight:"78vh", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <Box sx={{ width:"100%", maxWidth:460 }} className="au">
        <Box sx={{ textAlign:"center", mb:4 }}>
          <Box sx={{ width:54, height:54, borderRadius:3, mx:"auto", mb:2, background:indigoGradient, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <AutoStoriesIcon sx={{ color:"white", fontSize:26 }} />
          </Box>
          <Typography variant="h4" fontWeight={700}>Créer un compte</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt:.5 }}>Accédez à tous vos examens en ligne</Typography>
        </Box>

        <Paper sx={{ p:4, borderRadius:"16px" }}>
          {success ? (
            <Box sx={{ textAlign:"center", py:4 }}>
              <CheckCircleIcon sx={{ fontSize:54, color:"#22c55e", mb:1.5 }} />
              <Typography variant="h6" fontWeight={700}>Compte créé !</Typography>
              <Typography variant="body2" color="text.secondary">Redirection en cours…</Typography>
            </Box>
          ) : (
            <>
              {err && <Alert severity="error" sx={{ mb:2.5 }}>{err}</Alert>}
              <Box component="form" onSubmit={submit}>
                <Stack spacing={2}>
                  <TextField label="Nom d'utilisateur *" fullWidth required autoFocus value={form.username} onChange={set("username")} />
                  <TextField label="Email *" type="email" fullWidth required value={form.email} onChange={set("email")} />
                  <TextField label="Nom complet" fullWidth value={form.full_name} onChange={set("full_name")} />
                  <Box>
                    <TextField label="Mot de passe *" type="password" fullWidth required value={form.password} onChange={set("password")} />
                    {form.password.length > 0 && (
                      <Box sx={{ mt:1 }}>
                        <LinearProgress variant="determinate" value={(s/4)*100}
                          sx={{ "& .MuiLinearProgress-bar": { background: COLORS[s] } }} />
                        <Typography variant="caption" sx={{ color: COLORS[s], fontWeight: 600 }}>{LABELS[s]}</Typography>
                      </Box>
                    )}
                  </Box>
                  <TextField label="Confirmer le mot de passe *" type="password" fullWidth required
                    value={form.confirm} onChange={set("confirm")}
                    error={form.confirm.length>0 && form.confirm !== form.password}
                    helperText={form.confirm.length>0 && form.confirm !== form.password ? "Ne correspond pas" : ""} />
                  <Button type="submit" variant="contained" size="large" fullWidth disabled={loading} sx={{ py:1.3, mt:.5 }}>
                    {loading ? <CircularProgress size={20} color="inherit" /> : "Créer mon compte"}
                  </Button>
                </Stack>
              </Box>
              <Typography variant="body2" sx={{ mt:2.5, textAlign:"center", color:"text.secondary" }}>
                Déjà inscrit ?{" "}
                <Link to="/login" style={{ color: C.indigo[600], fontWeight:600, textDecoration:"none" }}>Se connecter</Link>
              </Typography>
            </>
          )}
        </Paper>
      </Box>
    </Box>
  );
}
